<template>
  <div class="wrapper">
    <page>
      <div slot="page-content-w100">
        <!-- <img class="block" v-if="!is_applying_apple && browser_size == 'small'" :src="`${GL.PIC_HOST}/static/img/banner/100years.png`" alt=""> -->
        <banner v-if="!havefun && !is_applying_apple && !is_applying_google && browser_size == 'small'" class="mb16"></banner>
        <div v-show="session_user" v-if="!is_applying_apple && !is_applying_google && !havefun">
          <div
            v-if="!is_applying_apple && !is_applying_google"
            class="flex-box flex-justify-content-space-between flex-align-items-center pl-0-16 pr-0-16 mq mt8"
          >
            <h1 slot="tit" class="fs20">{{$t('Feed.text1')}}</h1>
            <div class="flex-box flex-align-items-center">
              <router-link to="/dashboard/mark" class="purple gl-hover-text-purple mr16">{{$t('Feed.text2')}}</router-link>
              <router-link to="/dashboard/sponsoring" class="purple gl-hover-text-purple">{{$t('Feed.text3')}}</router-link>
            </div>
          </div>
          <div class="avatar-list flex-box" v-if="sponsoring.length > 0">
            <router-link
              class="block avatar-item relative"
              :to="$userlink(item.user, {tab:'feed'})"
              v-for="(item, i) in sponsoring"
              :key="i"
            >
              <avatar class="wh48" :is_no_href="true" :user="item.user">
                <div slot="doing" class="mt4">{{$t('Feed.text4')}} {{ item.user.creator.doing }}</div>
                <div slot="right" class="fs14 fwn flex-shrink-0">
                  <i v-if="item.new_post_count == 0" class="afd afd-arrow-right mr8 black-5"></i>
                  <tag class="circle purple" v-else>{{ item.new_post_count }}</tag>
                </div>
              </avatar>
            </router-link>
          </div>
          <template v-else>
              <div v-if="browser_size != 'small'" class="black-3 mt8 mq pl-0-16">{{$t('Feed.text5')}}</div>
              <div v-if="browser_size == 'small'" class="text-center mt32" @click="$mixin_router_push(`/search`)">
                  <div><i class="afd afd-search fs32 black-1"></i></div>
                  <div class="mt16 black-3 fs14">{{$t('Feed.text6')}}<span class="purple">{{$t('Feed.text7')}}</span></div>
              </div>
          </template>
          <template v-if="group_list.length > 0">
            <div
              class="flex-box flex-justify-content-space-between flex-align-items-center pl-0-16 pr-0-16 mq mt32"
            >
              <h1 slot="tit" class="fs20">{{$t('Feed.text8')}}</h1>
            </div>
            <div class="group-list" v-if="group_list.length > 0">
              <group-card class="mt16" v-for="(item, i) in group_list" :key="i" :group="item"></group-card>
            </div>
            <div v-else class="black-3 mt8 mq pl-0-16">{{$t('Feed.text9')}}</div>
          </template>
          <router-link to="/dashboard/order" v-if="session_user && session_user.has_purchased" class="purchased-box flex-box flex-justify-content-space-between p12 mt20 mr-0-16 ml-0-16 mq">
            <span>{{$t('Feed.text10')}}</span>
            <span class="purple">{{$t('Feed.text11')}}</span>
          </router-link>
        </div>
        <div class="content-wrapper mt32">
          <div class="content-left">
            <block-feed v-if="has_load" :is_public_feed="show_feed_type == 'public'" :is_my_rec_feed="show_feed_type == 'my'" :is_white_show="true" @tab_public_feed="tab_feed_type('public')">
              <div slot="tit" class="flex-box flex-a-center flex-bet pl-0-16 mq pb-16-8">
                <div class="flex-box flex-a-center">
                    <span v-if="!havefun && !is_applying_apple && !is_applying_google && session_user && session_user.user_id" class="feed-tit mr24 pointer" :class="{'on': show_feed_type == 'my'}" @click="tab_feed_type('my')">{{$t('Feed.text12')}}</span>
                    <span class="feed-tit pointer" :class="{'on': show_feed_type == 'public'}" @click="tab_feed_type('public')">{{$t('Feed.text13')}}</span>
                </div>
                <i v-if="!havefun && !is_applying_apple && !is_applying_google && show_feed_type == 'my'" class="afd afd-filter mq mr-0-16 fs16 black-5 pointer hover-bg-purple" @click="open_filter($event)"></i>
              </div>
            </block-feed>
          </div>
          <div
            v-if="browser_size != 'small' && !is_applying_apple && !is_applying_google && !havefun"
            class="content-right"
            style="margin-left: 60px; margin-top: 60px;"
          >
            <banner></banner>
          </div>
        </div>
      </div>
    </page>
  </div>
</template>

<script>
import { GET_MY_SPONSORING, GET_MY_JOINED_GROUP,GET_SESSION_USER } from '../api/config';
import { mapState } from 'vuex';
export default {
  name: 'feed',
  metaInfo() {
    let tit = `动态丨爱发电`;
    let key = `爱发电，订阅，创作者，赞助，粉丝，视频，文章，小说，音乐，绘画，动漫，摄影，游戏，艺术`;
    let desc = `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`;
    let url = location.href;
    return {
        title: tit,
        meta: [
            {
                name: "keywords",
                content: key,
            },
            {
                property:'og:title',
                content: tit,
            },
            {
                property:'og:description',
                content: desc,
            },
            {
                property:'og:url',
                content: url,
            }
        ],
    };
  },
  inject:['app_action_sheet'],
  data() {
    return {
      sponsoring: [],
      group_list: [],
      is_activated: false,
      show_feed_type: localStorage.getItem('show_feed_type') || 'public',
      has_load:false,
    };
  },
  computed: {
    ...mapState('app', ['session_user', 'browser_size','is_applying_apple', 'is_applying_google','havefun']),
    share_config(){
        return {
            url: window.location.href,
            source: `${location.origin}`,
            title: `动态丨爱发电`,
            description: `将创作的自由还给创作者！爱发电是让创作者简单地获得稳定收入的粉丝赞助平台。无论你在创作什么，都能在这里获得持续的资金支持，让创作从此更自由。`,
            pic: `https://static.afdiancdn.com/static/img/logo/logo.png`,
        };
    },
  },
  watch: {},
  beforeMount() {
    this.get_sponsoring();
    this.get_group_list();
  },
  mounted() {
    this.$mixin_share(this.share_config)
    this.init_tab()
  },
  activated() {
    this.is_activated = true;
  },
  beforeRouteLeave(to, from, next) {
    next(this.$mixin_client_router(to));
  },
  deactivated() {
    this.is_activated = false;
  },
  beforeDestroy() {},
  methods: {
    async init_tab(){
        let re = await this.$mixin_waitting_api(GET_SESSION_USER);
        this.has_load = true;
        if(!this.session_user || this.havefun == 1){
            this.show_feed_type = 'public'
            return false
        }
        // this.show_feed_type = this.session_user.is_paid_user == 1 && !this.is_applying_apple ? 'my' : 'public'
    },
    open_filter(e){
        this.app_action_sheet('open', {
            component:'action-feed-filter',
            target:e.target
        })
    },
    tab_feed_type(type){
        this.show_feed_type = type
        localStorage.setItem('show_feed_type', type)
    },
    async get_sponsoring() {
      if (this.$http.is_run(GET_MY_SPONSORING)) {
        return false;
      }
      let data = await this.$http.$axios(GET_MY_SPONSORING);
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      this.sponsoring = data.data.sponsoring;
    },
    async get_group_list() {
      if (this.$http.is_run(GET_MY_JOINED_GROUP)) {
        return false;
      }
      let data = await this.$http.$axios(GET_MY_JOINED_GROUP);

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      this.group_list = data.data.list;
      //   console.log(data);
    },

  },
};
</script>
<style lang="stylus" scoped>
.wrapper {
  .content-left {
    max-width: 640px;
  }

  .avatar-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .group-list {
    width: 640px;
  }

  // .group-list {
  // .vm-pic {
  // width: 64px;
  // height: 64px;
  // }
  // }
  .vm-group-card /deep/ {
    background: $white;
    width: 100%;
  }

  .avatar-item{
    padding: px2rem(24);
    box-sizing: border-box;
    background: $white;
    width: 48%;
    margin-top: 16px;
    border: 1px solid $grey;
    border-radius: px2rem(4);

    &:nth-child(2n+1) {
      margin-right: 4%;
    }

    .vm-avatar {
      align-items: center;
    }
  }
  .purchased-box{
      background rgba(0,0,0,.02);
      border-radius 5px;
      max-width 640px;
      box-sizing border-box;
  }

  .feed-tit{
    font-size:16px;
    color:$black-3;
    &.on{
        font-weight: bold;
        font-size:20px;
        color:$black;
    }
  }

  @media (max-width: $width-mobile) {
    background: $white;
    min-height:100vh !important;

    .vm-page /deep/ {
      .vm-nav-header-mobile {
        background: $white;
      }

      &.afd-client {
        .page-box {
          margin-top: px2rem(0);
        }
      }
    }

    .purchased-box{
        background rgba(0,0,0,.02);
        border-radius 5px;
    }

    .avatar-list {
      flex-direction: column;
    }

    .group-list {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
    }

    .vm-group-card /deep/ {
      background: $white;
      width: 100%;
      padding: 0;
      border: 0;
    }

    .avatar-item {
      padding: 0 16px;
      width: 100%;
      border: 0;
      border-radius: 0;
      margin-right: 0 !important;

      .right-info {
        top: -2px;
        right: 16px;
        bottom: 0px;
      }
    }

    .content-left {
      max-width: 100%;
      padding-bottom: px2rem(64);
    }
  }
}
</style>
